require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/modules/web.dom.iterable.js
 ** module id = 143
 ** module chunks = 0 1 2 3 10 11 12 13 14 15 16 17 19 20 21 22 26 33 34
 **/